import { NgClass, NgIf } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { NameInitialsPipe } from '../../../core/pipes/name-initals.pipe';

@Component({
  imports: [NameInitialsPipe, MatTooltip, MatIcon, NgIf, TranslatePipe, NgClass],
  selector: 'app-text-avatar',
  styleUrl: './text-avatar.component.scss',
  templateUrl: './text-avatar.component.html',
})
export class TextAvatarComponent {
  public text: InputSignal<string | undefined> = input<string>();
}
